import IMG_MOBILE from '../assets/images/profile/Mobile.png';
import IMG_PC_CONSOLE from '../assets/images/profile/PC-Console.png';

import IMG_ISTJ from '../assets/images/roles/istj.png';
import IMG_ISFJ from '../assets/images/roles/isfj.png';
import IMG_INFJ from '../assets/images/roles/infj.png';
import IMG_INTJ from '../assets/images/roles/intj.png';
import IMG_ISTP from '../assets/images/roles/istp.png';
import IMG_ISFP from '../assets/images/roles/isfp.png';
import IMG_INFP from '../assets/images/roles/infp.png';
import IMG_INTP from '../assets/images/roles/intp.png';
import IMG_ESTP from '../assets/images/roles/estp.png';
import IMG_ESFP from '../assets/images/roles/esfp.png';
import IMG_ENFP from '../assets/images/roles/enfp.png';
import IMG_ENTP from '../assets/images/roles/entp.png';
import IMG_ESTJ from '../assets/images/roles/estj.png';
import IMG_ESFJ from '../assets/images/roles/esfj.png';
import IMG_ENFJ from '../assets/images/roles/enfj.png';
import IMG_ENTJ from '../assets/images/roles/entj.png';

import IMG_GENRE_ACTION from '../assets/images/profile/Action.png';
import IMG_GENRE_ADVENTURE from '../assets/images/profile/Adventure.png';
import IMG_GENRE_CASUAL from '../assets/images/profile/Casual.png';
import IMG_GENRE_RACING from '../assets/images/profile/Racing.png';
import IMG_GENRE_RPG from '../assets/images/profile/RPG.png';
import IMG_GENRE_SHOOTER from '../assets/images/profile/Shooter.png';
import IMG_GENRE_SIMULATION from '../assets/images/profile/Simulation.png';
import IMG_GENRE_SOFTWARE from '../assets/images/profile/Software.png';
import IMG_GENRE_SPORTS from '../assets/images/profile/Sports.png';
import IMG_GENRE_STRATEGY from '../assets/images/profile/Strategy.png';
import IMG_GENRE_GACHA from '../assets/images/profile/gacha.png';

import type { IYearConfig } from '../../constants';

/**
 * 2026 年份角色配置映射
 * 使用 2026 前缀的 i18n key
 */
export const USER_ROLE_CONFIG_MAP_2026: Record<IQuarterReportUserRoleCode, IQuarterReportUserRoleConfig> = {
  ISTJ: {
    roleCode: 'ISTJ',
    roleName: 'dbu_quarter_report_2026_role_name_istj',
    roleImage: IMG_ISTJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_istj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_1',
  },
  ISFJ: {
    roleCode: 'ISFJ',
    roleName: 'dbu_quarter_report_2026_role_name_isfj',
    roleImage: IMG_ISFJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_isfj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_2',
  },
  INFJ: {
    roleCode: 'INFJ',
    roleName: 'dbu_quarter_report_2026_role_name_infj',
    roleImage: IMG_INFJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_infj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_3',
  },
  INTJ: {
    roleCode: 'INTJ',
    roleName: 'dbu_quarter_report_2026_role_name_intj',
    roleImage: IMG_INTJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_intj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_4',
  },
  ISTP: {
    roleCode: 'ISTP',
    roleName: 'dbu_quarter_report_2026_role_name_istp',
    roleImage: IMG_ISTP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_istp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_5',
  },
  ISFP: {
    roleCode: 'ISFP',
    roleName: 'dbu_quarter_report_2026_role_name_isfp',
    roleImage: IMG_ISFP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_isfp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_5',
  },
  INFP: {
    roleCode: 'INFP',
    roleName: 'dbu_quarter_report_2026_role_name_infp',
    roleImage: IMG_INFP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_infp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_6',
  },
  INTP: {
    roleCode: 'INTP',
    roleName: 'dbu_quarter_report_2026_role_name_intp',
    roleImage: IMG_INTP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_intp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_1',
  },
  ESTP: {
    roleCode: 'ESTP',
    roleName: 'dbu_quarter_report_2026_role_name_estp',
    roleImage: IMG_ESTP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_estp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_7',
  },
  ESFP: {
    roleCode: 'ESFP',
    roleName: 'dbu_quarter_report_2026_role_name_esfp',
    roleImage: IMG_ESFP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_esfp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_8',
  },
  ENFP: {
    roleCode: 'ENFP',
    roleName: 'dbu_quarter_report_2026_role_name_enfp',
    roleImage: IMG_ENFP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_enfp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_9',
  },
  ENTP: {
    roleCode: 'ENTP',
    roleName: 'dbu_quarter_report_2026_role_name_entp',
    roleImage: IMG_ENTP,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_entp',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_4',
  },
  ESTJ: {
    roleCode: 'ESTJ',
    roleName: 'dbu_quarter_report_2026_role_name_estj',
    roleImage: IMG_ESTJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_estj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_10',
  },
  ESFJ: {
    roleCode: 'ESFJ',
    roleName: 'dbu_quarter_report_2026_role_name_esfj',
    roleImage: IMG_ESFJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_esfj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_11',
  },
  ENFJ: {
    roleCode: 'ENFJ',
    roleName: 'dbu_quarter_report_2026_role_name_enfj',
    roleImage: IMG_ENFJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_enfj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_12',
  },
  ENTJ: {
    roleCode: 'ENTJ',
    roleName: 'dbu_quarter_report_2026_role_name_entj',
    roleImage: IMG_ENTJ,
    roleExclusiveCopy: 'dbu_quarter_report_2026_role_exclusive_copy_entj',
    belongGameId: '',
    belongGameName: 'dbu_quarter_report_2026_game_name_7',
  },
};

/**
 * 2026 品类图标映射
 */
export const GENRE_ICON_MAP_2026: IRecord<string> = {
  ACTION: IMG_GENRE_ACTION,
  ADVENTURE: IMG_GENRE_ADVENTURE,
  CASUAL: IMG_GENRE_CASUAL,
  RPG: IMG_GENRE_RPG,
  RACING: IMG_GENRE_RACING,
  SHOOTER: IMG_GENRE_SHOOTER,
  SIMULATION: IMG_GENRE_SIMULATION,
  SOFTWARE: IMG_GENRE_SOFTWARE,
  SPORTS: IMG_GENRE_SPORTS,
  STRATEGY: IMG_GENRE_STRATEGY,
  GACHA: IMG_GENRE_GACHA,
};

/**
 * 2026 实体类型图标映射
 */
export const ENTITY_TYPE_ICON_MAP_2026: Record<IEntityType, string> = {
  mobile: IMG_MOBILE,
  pc: IMG_PC_CONSOLE,
  console: IMG_PC_CONSOLE,
  combine: IMG_PC_CONSOLE,
};

/**
 * 2026 年份配置
 */
export const yearConfig2026: IYearConfig = {
  USER_ROLE_CONFIG_MAP: USER_ROLE_CONFIG_MAP_2026,
  GENRE_ICON_MAP: GENRE_ICON_MAP_2026,
  ENTITY_TYPE_ICON_MAP: ENTITY_TYPE_ICON_MAP_2026,
};
